import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function ChecklistSection() {
  return (
    <PostSection id="checklist-accion" title="Checklist 2026: plan de acción inmediato">
      <p>
        No esperes más. Estas son las acciones concretas que puedes implementar hoy para adelantarte 
        a los cambios que ya están ocurriendo.
      </p>

      <h3 id="pasos-implementar" className="text-xl font-bold text-white mt-8 mb-4">
        7 pasos para implementar hoy
      </h3>
      <PostHighlight>
        La clave no es «publicar más», sino publicar mejor. En 2026, 5 artículos realmente útiles 
        y diferenciados valen más que 30 artículos genéricos.
      </PostHighlight>
      <ol className="list-decimal pl-6 space-y-3 mt-4">
        <li>
          <strong>Rediseña tu estrategia como GEO + SEO:</strong> escribe para humanos, pero también 
          para IA. Usa estructura, FAQs, datos y contexto.
        </li>
        <li>
          <strong>Produce contenido multimodal:</strong> textos, imágenes optimizadas, infografías, 
          vídeo o audio cuando tenga sentido.
        </li>
        <li>
          <strong>Optimiza la experiencia:</strong> velocidad, usabilidad móvil, accesibilidad y 
          Core Web Vitals.
        </li>
        <li>
          <strong>Construye autoridad de marca:</strong> testimonios, reseñas, contenido original, 
          datos propios y credibilidad verificable.
        </li>
        <li>
          <strong>Segmenta contenidos:</strong> por intención, contexto y localización. Evita textos 
          genéricos globales.
        </li>
        <li>
          <strong>Usa la IA como asistente, no como autor:</strong> genera borradores e ideas con IA, 
          pero revisa, personaliza y añade tu experiencia.
        </li>
        <li>
          <strong>Mide resultados más allá de visitas:</strong> retención, tiempo en página, menciones, 
          citas por IA e interacciones reales.
        </li>
      </ol>

      <h3 id="errores-evitar" className="text-xl font-bold text-white mt-8 mb-4">
        Errores comunes a evitar
      </h3>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Publicar en masa sin diferenciación:</strong> 30 artículos «correctos» compiten entre sí y diluyen tu autoridad</li>
        <li><strong>Contenido 100% generado por IA:</strong> sin experiencia real, verificación ni matices humanos</li>
        <li><strong>Ignorar la experiencia de usuario:</strong> un sitio lento o desordenado anula cualquier estrategia de contenido</li>
        <li><strong>Solo optimizar para keywords:</strong> los motores de IA buscan significado y contexto, no repeticiones</li>
        <li><strong>No actualizar contenido existente:</strong> el contenido obsoleto pierde relevancia rápidamente en 2026</li>
      </ul>

      <div className="mt-8 p-6 bg-seo-blue/10 border border-seo-bright/20 rounded-lg">
        <h4 className="text-lg font-bold text-seo-bright mb-3">🎯 Conclusión</h4>
        <p className="text-gray-300">
          2026 representa un punto de inflexión: el SEO deja de ser solo cuestión de rankings para ser 
          cuestión de <strong>visibilidad inteligente</strong>. Quien entienda que los buscadores ya no son 
          solo listados, sino motores generativos, y adapte su estrategia combinando contenido de valor, 
          estructura clara, experiencia de usuario, autoridad de marca y formatos variados, tendrá una 
          ventaja competitiva real.
        </p>
      </div>
    </PostSection>
  );
}
